<template>
  <label class="photo__upload">
    <div class="photo__loading" v-if="isLoading">
      <spring-spinner
        class="loading"
        :animation-duration="1000"
        :size="40"
        :color="$themes.primary"
      ></spring-spinner>
    </div>
    <input type="file" :disabled="isLoading" @input="inputImage" />
    <va-icon name="fa fa-file-image-o" :size="40">
      <va-icon
        name="fa fa-plus-square-o"
        :style="{ transform: 'translate(-15px, -20px)', background: $themes.background }"
        :size="30"
      ></va-icon>
    </va-icon>
  </label>
</template>
<script>
import { SpringSpinner } from 'epic-spinners'

export default {
  components: { SpringSpinner },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    inputImage(e) {
      const file = e.target.files[0]

      if (file && file.type.split('/').includes('image')) {
        this.$emit('input', file)
      } else {
        alert(this.$t('notValidFormat'))
        e.preventDefault()
        e.target.value = ''
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.loading {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;
}

.photo {
  &__loading {
    position: absolute;
    opacity: 0.8;
    z-index: 99;
    width: 100%;
    height: 100%;
    background-color: var(--va-background);
    left: 0;
    top: 0;
  }

  &__upload {
    height: 100%;
    min-height: 112px;
    max-width: 100%;
    max-height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    border: dashed 2px var(--va-textColor);

    input {
      cursor: pointer;
      height: 100%;
      position: absolute;
      width: 100%;
      opacity: 0;
    }
  }
}
</style>
